import React, { useEffect, useState } from 'react';
import { AddSaveContactDto } from '../../../types';
import {
  AddContactInitialValues,
  AddContactValidationValues,
  editContactValidationValues,
} from '../../../initial-values';
import { isValidEmail, isValidationValidated } from '../../../utils/helper';
import { RootState } from '../../../redux/rootReducer';
import { addSavedContact, updateSavedContact } from '../../../api/privateApis';
import X from '../../../assets/icons/new_icon/x.svg';

import { useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { useLocation } from 'react-router-dom';
interface Props {
  onSuccess: any;
  editData?: any;
  onClose: any;
}
const AddSavedContactModal = ({ onSuccess, editData, onClose }: Props) => {
  const userData = useSelector(
    (state: RootState) => state.mainAppData.userData
  );
  const { enqueueSnackbar } = useSnackbar();
  const location = useLocation();
  const user = new URLSearchParams(location.search).get('user');
  const isVendor = new URLSearchParams(location.search).get('is_vendor');
  const account = new URLSearchParams(location.search).get('account_number');
  const [savedContactForm, setSavedContactForm] = useState<AddSaveContactDto>(
    editData ? editData : AddContactInitialValues
  );
  const [savedContactFormValidation, setSavedContactFormValidation] =
    useState<any>(
      editData ? editContactValidationValues : AddContactValidationValues
    );
  const [loading, setLoading] = useState(false);
  const [validating, setValidating] = useState(false);
  function handleAction() {
    setValidating(true);
    if (
      isValidationValidated(savedContactFormValidation) &&
      savedContactForm.username !== '' &&
      savedContactForm.account_number !== ''
    ) {
      setLoading(true);
      if (editData) {
        updateSavedContact(editData.id, savedContactForm)
          .then((response) => {
            responseHandle(response);
            enqueueSnackbar('Contact has been updated', { variant: 'success' });
          })
          .catch((e) => {
            setLoading(false);
            setValidating(false);
          });
      } else {
        addSavedContact(savedContactForm)
          .then((response) => {
            responseHandle(response);
            enqueueSnackbar('Contact has been added', { variant: 'success' });
          })
          .catch((e) => {
            setLoading(false);
            setValidating(false);
          });
      }
    } else {
      enqueueSnackbar('Please fill all the fields.', { variant: 'error' });
    }
  }
  function responseHandle(response: any) {
    if (!response?.data?.is_error) {
      onSuccess();
      onClose();
    }
    setLoading(false);
    setValidating(false);
  }
  useEffect(() => {
    setSavedContactForm({
      ...savedContactForm,
      username: user ? user : userData?.username,
      account_number: account ? account : userData?.account_number,
      is_vendor: user ? isVendor === 'true' : undefined,
    });
  }, []);

  const handleClose = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className='modal'
      id='contactmodal'
      style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5) ' }}
      tabIndex={-1}
      aria-labelledby='contact_modal_label'
      aria-hidden='true'
      onClick={handleClose}
    >
      {loading && (
        <div className='loader-container'>
          <div className='spinner'></div>
        </div>
      )}
      <div className='modal-dialog modal-md'>
        <div className='modal-content'>
          <div className='modal-header d-flex w-100 justify-content-between px-3 py-2'>
            <h3 className='newubbemodalheading  mt-3'>Contact Details</h3>
            <img
              src={X}
              onClick={() => onClose()}
              style={{ cursor: 'pointer' }}
            />
          </div>
          <div className='modal-body'>
            <input
              type='hidden'
              className='form-control ubbe-input'
              id='saved_contact_id'
              value='-1'
            />
            <div className='mb-1'>
              <label className=' globalInputLabel' htmlFor='name'>
                Company
                <span className='text-danger fw-bold'>*</span>
              </label>
              <input
                className={`form-control ubbe-input ${
                  validating && savedContactForm.contact.company_name !== ''
                    ? 'is-valid'
                    : validating && savedContactForm.contact.company_name === ''
                    ? 'is-invalid'
                    : ''
                } 
                ${
                  savedContactForm.contact.company_name
                    ? 'highlighted-border'
                    : ''
                }
                `}
                data-width='100%'
                data-live-search='true'
                id='cmpany_name'
                placeholder='Company'
                maxLength={30}
                value={savedContactForm.contact.company_name}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  setSavedContactFormValidation({
                    ...savedContactFormValidation,
                    company_name: e.target.value !== '',
                  });
                  setSavedContactForm({
                    ...savedContactForm,
                    contact: {
                      ...savedContactForm.contact,
                      company_name: e.target.value,
                    },
                  });
                }}
              />
              {validating && savedContactForm.contact.company_name === '' && (
                <div className='error_text'>
                  {'Please provide a valid company name.'}
                </div>
              )}
            </div>
            <div className='mb-1 mt-3'>
              <label className=' globalInputLabel' htmlFor='name'>
                Name
                <span className='text-danger fw-bold'>*</span>
              </label>
              <input
                className={`form-control ubbe-input ${
                  validating && savedContactForm.contact.name !== ''
                    ? 'is-valid'
                    : validating && savedContactForm.contact.name === ''
                    ? 'is-invalid'
                    : ''
                } 
                ${savedContactForm.contact.name ? 'highlighted-border' : ''}`}
                data-width='100%'
                data-live-search='true'
                id='name'
                placeholder='Full Name'
                maxLength={30}
                value={savedContactForm.contact.name}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  setSavedContactFormValidation({
                    ...savedContactFormValidation,
                    name: e.target.value !== '',
                  });
                  setSavedContactForm({
                    ...savedContactForm,
                    contact: {
                      ...savedContactForm.contact,
                      name: e.target.value,
                    },
                  });
                }}
              />
              {validating && savedContactForm.contact.name === '' && (
                <div className='error_text'>
                  {'Please provide a valid name'}
                </div>
              )}
            </div>
            <div className='mb-1 mt-3'>
              <label htmlFor='email' className='globalInputLabel'>
                Email Address
                <span className='text-danger fw-bold'>*</span>
              </label>
              <input
                type='text'
                className={`form-control ubbe-input ${
                  validating && isValidEmail(savedContactForm.contact.email)
                    ? 'is-valid'
                    : validating &&
                      !isValidEmail(savedContactForm.contact.email)
                    ? 'is-invalid'
                    : ''
                }
                
                ${savedContactForm.contact.email ? 'highlighted-border' : ''}`}
                id='email'
                placeholder='Email'
                autoComplete='new-password'
                maxLength={100}
                value={savedContactForm.contact.email}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  setSavedContactFormValidation({
                    ...savedContactFormValidation,
                    email:
                      e.target.value !== '' && isValidEmail(e.target.value),
                  });
                  setSavedContactForm({
                    ...savedContactForm,
                    contact: {
                      ...savedContactForm.contact,
                      email: e.target.value,
                    },
                  });
                }}
              />
              {validating && !isValidEmail(savedContactForm.contact.email) && (
                <div className='error_text'>
                  {'Please provide a valid email'}
                </div>
              )}
            </div>
            <div className='mb-1 mt-3'>
              <label className='globalInputLabel' htmlFor='phone'>
                Phone Number
                <span className='text-danger fw-bold'>*</span>
              </label>
              <input
                className={`form-control ubbe-input ${
                  validating && savedContactForm.contact.phone !== ''
                    ? 'is-valid'
                    : validating && savedContactForm.contact.phone === ''
                    ? 'is-invalid'
                    : ''
                } ${
                  savedContactForm.contact.phone ? 'highlighted-border' : ''
                }`}
                data-width='100%'
                data-live-search='true'
                id='phone'
                placeholder='Phone'
                maxLength={14}
                minLength={10}
                value={savedContactForm.contact.phone}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  setSavedContactFormValidation({
                    ...savedContactFormValidation,
                    phone: e.target.value !== '',
                  });
                  setSavedContactForm({
                    ...savedContactForm,
                    contact: {
                      ...savedContactForm.contact,
                      phone: e.target.value.replace(/[^0-9]/g, ''),
                    },
                  });
                }}
              />
              {validating && savedContactForm.contact.phone === '' && (
                <div className='error_text'>
                  {'Please provide a valid phone'}
                </div>
              )}
            </div>
            <div className='d-flex align-items-center gap-3 mt-4'>
              <div className='form-check   '>
                <input
                  type='checkbox'
                  className='form-check-input'
                  checked={savedContactForm.is_origin}
                  id='is_origin'
                  onChange={(e) => {
                    setSavedContactForm({
                      ...savedContactForm,
                      is_origin: e.target.checked,
                    });
                  }}
                />
                <label
                  className='form-check-label globalInputLabel'
                  htmlFor='is_origin'
                  style={{ fontWeight: '300' }}
                >
                  Show in origin?
                </label>
                <p className='text-danger' id='is_origin_error'></p>
              </div>
              <div className='form-check'>
                <input
                  type='checkbox'
                  className='form-check-input'
                  id='is_destination'
                  checked={savedContactForm.is_destination}
                  onChange={(e) => {
                    setSavedContactForm({
                      ...savedContactForm,
                      is_destination: e.target.checked,
                    });
                  }}
                />
                <label
                  className='form-check-label globalInputLabel'
                  style={{ fontWeight: '300' }}
                  htmlFor='is_destination'
                >
                  Show in destination?
                </label>
                <p className='text-danger' id='is_destination_error'></p>
              </div>
            </div>
          </div>
          <div className='row mt-3 mb-2'>
            <div className='col-sm-12'>
              <p
                className='btn ubbe-blue-bg px-4 p-2 w-100 rounded-3 text-light d-flex m-auto justify-content-center align-items-center mb-2'
                style={{ maxWidth: 'max-content', height: '48px' }}
                onClick={() => {
                  handleAction();
                }}
              >
                Save Contact
              </p>
              <u
                className='m-auto d-flex justify-content-center labelText'
                style={{ cursor: 'pointer' }}
                aria-label='Close'
                onClick={() => onClose()}
              >
                Cancel
              </u>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddSavedContactModal;
